import { useCallback, useState } from 'react';
import API from '../../../Infrastructure/API';
import { MultiFactorAuthenticationType } from '../../../Infrastructure/API/MultiFactorAuthentication/list';

interface Settings {
  authToken?: string;
  type: MultiFactorAuthenticationType;
}

export default function useMultiFactorAuthenticationActivate({ authToken, type }: Settings) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [fetched, setFetched] = useState(false);

  const activate = useCallback(
    (token?: string) => {
      if (!authToken) {
        return;
      }

      setLoading(true);
      setError(false);

      API.multiFactorAuthentication
        .activate({ token, type }, { authToken })
        .then(() => {
          setFetched(true);
        })
        .catch(() => {
          setError(true);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [authToken, type],
  );

  return {
    activate,
    loading,
    error,
    fetched,
  };
}
